import { merge } from '../../helper';
import removeClass from '../../general/class/removeClass';

// ----------------------------------------------------------------------------

function general(element: HTMLElement | HTMLElement[], config: Record<string, any> = {}): void {
    validation(element, config.validation);
}

// ----------------------------------------------------------------------------

function validation(element: HTMLElement | HTMLElement[], config: Record<string, any> = {}): void {
    // Default Config
    const defConfig: Record<string, any> = {
        selector: 'tbody > tr > td',
    };

    // Merge
    merge(defConfig, config);

    // ------------------------------------------------------------------------

    //
    let elements: any = [element];

    //
    if (element instanceof HTMLElement) {
        elements = element.querySelectorAll(defConfig.selector);
    }

    // Foreach Element
    for (const element of elements) {
        // Remove class
        removeClass(element, 'table-valid table-invalid');

        // Get element (row)
        const elRow = element.closest('tr');
        // If there is element (row)
        if (elRow) {
            // Remove class
            removeClass(elRow, 'table-valid table-invalid');
        }
    }
}

// ----------------------------------------------------------------------------

export { general, validation };
